import React, { useState } from 'react';
import { ChevronDown, Clock, UserMinus, UserPlus } from 'lucide-react';
import { OwnerButton, OwnerInfoList, OwnerShell } from '../OwnerShell';
import { StatusBadge } from '../../common/StatusBadge';
import { PersonPhoto } from '../../common/PersonPhoto';
import { useMyVehicle } from '../../../hooks/useMyVehicles';
import { useOwnerService } from '../../../contexts/OwnerServiceContext';
import { getDriver } from '../../../data/drivers';
import { ownerProfile } from '../../../data/ownerProfile';
import { toBn } from '../../../utils/bn';
import type { OwnerNav } from '../../../types/owner';
export function OwnerDrivers({
  nav
}: {
  nav: OwnerNav;
}) {
  const mv = useMyVehicle(nav.vehicleId);
  const {
    requests,
    submitRequest
  } = useOwnerService();
  const [open, setOpen] = useState<string | null>(null);
  const [confirm, setConfirm] = useState<string | null>(null);
  if (!mv) return null;
  const {
    vehicle: v,
    driverIds
  } = mv;
  const pending = requests.filter(r => r.vehicleId === v.id && (r.kind === 'চালক সংযুক্তি' || r.kind === 'চালক অপসারণ') && (r.status === 'অপেক্ষমাণ' || r.status === 'পর্যালোচনাধীন'));
  const cng = v.type === 'cng';
  const requestRemoval = (id: string) => {
    const d = getDriver(id);
    if (!d) return;
    const rid = submitRequest({
      kind: 'চালক অপসারণ',
      ownerName: ownerProfile.name,
      vehicleReg: v.reg,
      subject: 'অনুমোদিত চালক অপসারণ',
      current: `${d.name} (${d.license})`,
      proposed: 'তালিকা থেকে অপসারণ',
      reason: 'চালক আর এই গাড়ি চালান না',
      vehicleId: v.id,
      driverId: id,
      attachments: 0
    });
    setConfirm(null);
    nav.showToast(`অপসারণের আবেদন জমা হয়েছে • ${rid}`);
  };
  return <OwnerShell nav={nav} title="সংযুক্ত চালকের তথ্য" subtitle={v.reg} footer={<OwnerButton variant="green" onClick={() => nav.go('addDriver')} data-id="element-1529" data-mp="z8pgq14hjo2b"><UserPlus className="h-5 w-5" data-id="element-1530" data-mp="3f0n6drvxi1ui" />{cng ? 'চালক সংযুক্তির আবেদন' : 'রাইডার সংযুক্তির আবেদন'}</OwnerButton>} data-id="element-1528" data-mp="ud0gdvkn634y">
      <p className="mb-3 text-[12px] text-slate-500" data-id="element-1531" data-mp="3k0huxos8efce">{cng ? `এই সিএনজির ${toBn(driverIds.length)} জন অনুমোদিত চালক। নতুন চালক যুক্ত বা অপসারণ ডিএমপি অনুমোদনের পর কার্যকর হবে।` : 'মোটরসাইকেলের মালিক/রাইডার এবং অনুমোদিত অতিরিক্ত রাইডার।'}</p>

      {!cng && <div className="mb-3 flex items-center gap-3 rounded-xl border border-border bg-white p-3" data-id="element-1532" data-mp="1lks93prh2l0s">
          <PersonPhoto src={ownerProfile.photo} name={ownerProfile.name} size={48} data-id="element-1533" data-mp="1gpcxl4gxt17j" />
          <div className="flex-1" data-id="element-1534" data-mp="1bqih496fzoql">
            <p className="text-sm font-semibold text-navy-900" data-id="element-1535" data-mp="16u1g4ee59fw3">{ownerProfile.name}</p>
            <p className="text-[11px] text-slate-500" data-id="element-1536" data-mp="12ry3vnjni79r">মালিক ও প্রধান রাইডার • লাইসেন্স: BRTA-DL-0098712</p>
          </div>
          <StatusBadge tone="green" className="!text-[10.5px]" data-id="element-1537" data-mp="xs1xxire85rk">সক্রিয়</StatusBadge>
        </div>}

      <div className="space-y-2.5" data-id="element-1538" data-mp="suk12qqnhgzx">
        {driverIds.map((id, i) => {
        const d = getDriver(id);
        if (!d) return null;
        const removing = pending.some(r => r.driverId === id && r.kind === 'চালক অপসারণ');
        return <div key={id} className="rounded-xl border border-border bg-white p-3 shadow-sm" data-id="element-1539" data-mp="2n5yr78nkpig7" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-1540" data-mp="2upgd2soaikfx">
                <PersonPhoto src={d.photo} name={d.name} size={52} rounded="md" data-id="element-1541" data-mp="2zpc8i3ix93jv" />
                <div className="min-w-0 flex-1" data-id="element-1542" data-mp="34gu6cipneo0m">
                  <p className="text-[10.5px] font-semibold text-slate-400" data-id="element-1543" data-mp="34j6xnmhaqaqc">চালক {toBn(i + 1)}</p>
                  <p className="text-[14.5px] font-semibold text-navy-900" data-id="element-1544" data-mp="39i9s6czngyk2">{d.name}</p>
                  <p className="font-mono text-[11px] text-slate-500" data-id="element-1545" data-mp="2btzs43jfckvl">লাইসেন্স: {d.license}</p>
                  <p className="font-mono text-[11px] text-slate-500" data-id="element-1546" data-mp="2gs1hf67g1gfi">মোবাইল: {toBn(d.mobile.replace('-', ''))}</p>
                </div>
                <StatusBadge tone={removing ? 'orange' : 'green'} className="!text-[10.5px]" data-id="element-1547" data-mp="2qppe41om0y0b">{removing ? 'অপসারণ অপেক্ষমাণ' : 'সক্রিয়'}</StatusBadge>
              </div>
              {open === id && <div className="mt-2.5 rounded-lg bg-slate-50 px-3" data-id="element-1548" data-mp="5zghc7y9antl">
                  <OwnerInfoList rows={[['লাইসেন্সের ধরন', d.licenseType], ['লাইসেন্সের মেয়াদ', d.expiry], ['চালক QR ID', d.qrId], ['BRTA যাচাই', d.brtaVerified ? '✓ যাচাইকৃত' : 'অপেক্ষমাণ']]} data-id="element-1549" data-mp="5xnc8x3akbnp" />
                </div>}
              {confirm === id && <div className="mt-2.5 rounded-lg border border-red-200 bg-red-50 p-2.5 text-[12px] text-red-800" data-id="element-1550" data-mp="dk0sjvgndk74">
                  <p data-id="element-1551" data-mp="8ibjglczjglo">{d.name}-কে অপসারণের আবেদন করবেন? ডিএমপি অনুমোদনের পর কার্যকর হবে।</p>
                  <div className="mt-2 grid grid-cols-2 gap-2" data-id="element-1552" data-mp="micsio3eluc8">
                    <button onClick={() => setConfirm(null)} className="rounded-md border border-slate-300 bg-white py-1.5 font-semibold text-slate-700" data-id="element-1553" data-mp="iilvw3r74jzs">বাতিল</button>
                    <button onClick={() => requestRemoval(id)} className="rounded-md bg-red-600 py-1.5 font-semibold text-white" data-id="element-1554" data-mp="wbbjgcmdhwz0">আবেদন করুন</button>
                  </div>
                </div>}
              <div className="mt-2.5 grid grid-cols-2 gap-2 border-t border-slate-100 pt-2.5" data-id="element-1555" data-mp="165allbmg5gqy">
                <button onClick={() => setOpen(open === id ? null : id)} className="flex items-center justify-center gap-1 rounded-lg bg-navy-50 py-2 text-[12px] font-semibold text-navy-800" data-id="element-1556" data-mp="116qw518n9mtu">
                  <ChevronDown className={`h-3.5 w-3.5 transition ${open === id ? 'rotate-180' : ''}`} data-id="element-1557" data-mp="1otuoqom3qjea" />চালকের তথ্য দেখুন
                </button>
                <button disabled={removing} onClick={() => setConfirm(id)} className="flex items-center justify-center gap-1 rounded-lg bg-red-50 py-2 text-[12px] font-semibold text-red-700 disabled:opacity-40" data-id="element-1558" data-mp="1fuhg1y5sxyum">
                  <UserMinus className="h-3.5 w-3.5" data-id="element-1559" data-mp="15xwb1cts8nqs" />চালক অপসারণের আবেদন
                </button>
              </div>
            </div>;
      })}
        {!cng && driverIds.length === 0 && <p className="rounded-xl border border-dashed border-slate-300 p-4 text-center text-xs text-slate-500" data-id="element-1560" data-mp="x5ucxl76rjjo">কোনো অতিরিক্ত অনুমোদিত রাইডার নেই</p>}

        {pending.filter(r => r.kind === 'চালক সংযুক্তি').map(r => <div key={r.id} className="flex items-center gap-3 rounded-xl border border-dashed border-amber-300 bg-amber-50/60 p-3" data-id="element-1561" data-mp="n63jzny9xclp">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-amber-100 text-amber-700" data-id="element-1562" data-mp="43t5ve3gyrs3"><Clock className="h-5 w-5" data-id="element-1563" data-mp="3qhkpg26o8d9c" /></span>
            <div className="min-w-0 flex-1" data-id="element-1564" data-mp="3qicmlhfx2j1q">
              <p className="text-[13px] font-semibold text-navy-900" data-id="element-1565" data-mp="3qf88nscng8xv">{r.proposed}</p>
              <p className="font-mono text-[10.5px] text-slate-500" data-id="element-1566" data-mp="3lgdiu6g9lk49">{r.id} • ডিএমপি অনুমোদন অপেক্ষমাণ</p>
            </div>
          </div>)}
      </div>
    </OwnerShell>;
}